 export const orderingByCleaner = [
     {name: 'Спочатку нові', ordering: ''},
     {name: 'Ціна: від нижчої до вищої', ordering: 'request_price'},
     {name: 'Ціна: від вищої до нижчої', ordering: '-request_price'},
     // {name: 'За рейтингом', ordering: '-rating'},
];
